import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Alert, Box, CircularProgress, Tab, Typography } from '@mui/material';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useDomainReadQuery } from '../api/domain.js';
import { AnalysisList } from './AnalysisList.js';
import { SnapshotList } from './SnapshotList.js';

type DomainViewParams = {
  projectId: string;
  domainId: string;
};

export function DomainView() {
  const { projectId, domainId } = useParams<DomainViewParams>();
  if (!projectId || !domainId) throw new Error('Missing parameter');

  const [value, setValue] = useState(0);
  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
  };

  const root = useDomainReadQuery(projectId, domainId);
  if (root.isLoading) return <CircularProgress />;
  if (root.isError) return <Alert severity="error">{`Error: ${root.error.message}`}</Alert>;

  return (
    <Box>
      <Box>
        <Typography variant="h5">Domain {root.data.name}</Typography>
      </Box>
      <TabContext value={value.toString()}>
        <TabList value={value} onChange={handleChange}>
          <Tab label="Snapshots" value="0" />
          <Tab label="Analyses" value="1" />
          <Tab label="Details" value="2" />
        </TabList>

        <TabPanel value="0">
          <SnapshotList type="dns" projectId={projectId} resourceId={domainId} />
        </TabPanel>

        <TabPanel value="1">
          <AnalysisList type="dns" projectId={projectId} resourceId={domainId} />
        </TabPanel>
        <TabPanel value="2">
          <Typography variant="h5">Test Details</Typography>
          <pre>{JSON.stringify(root.data, null, 2)}</pre>
        </TabPanel>
      </TabContext>
    </Box>
  );
}
